import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { useSelector } from '../../context/Redux';
import { taskQueuesSearchFetcher } from '../../query/searchTaskQueues';
import { userIdSelector } from '../../redux/selectors/auth';
import debounce from 'react-utils/debounce';
import { DEFAULT_QUEUES_PER_PAGE } from '../../constants/queues';
import { useJitaSelectedUserId } from '../../hooks/useJitaSelectedUserId';
import { jsx as _jsx } from "react/jsx-runtime";
const DEBOUNCE_SEARCH_MS = 400;
export function QueueSelect({
  'data-test-id': dataTestId,
  'data-selenium-test': dataSeleniumTest,
  onChange,
  value
}) {
  const userId = useSelector(userIdSelector);
  const jitaSelectedUserId = useJitaSelectedUserId();
  const ButtonContent = () => value.length > 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'tasks-table.filters.queue.numSelected',
    options: {
      numSelected: value.length
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'tasks-table.filters.queue.label'
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadOptions = useCallback(debounce((input, callback, pagination = {}) => {
    return taskQueuesSearchFetcher({
      limit: DEFAULT_QUEUES_PER_PAGE,
      offset: pagination.offset || 0,
      searchQuery: input,
      userId: jitaSelectedUserId || userId
    }).then(response => {
      callback(null, {
        options: response.results.map(result => ({
          text: result.name,
          value: result.id.toString()
        })),
        pagination: {
          hasMore: response.hasMore,
          length: response.total,
          offset: response.offset
        }
      });
    });
  }, DEBOUNCE_SEARCH_MS), [jitaSelectedUserId, userId]);
  return /*#__PURE__*/_jsx(UISelect, {
    anchorType: "button",
    ButtonContent: ButtonContent,
    buttonUse: "transparent",
    "data-selenium-test": dataSeleniumTest,
    "data-test-id": dataTestId,
    loadOptions: loadOptions,
    menuWidth: "auto",
    multi: true,
    onChange: onChange,
    value: value
  });
}